
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../molecules/organization/FilterContainer.vue";
import { QuiltyInsightsFilterStore } from "../stores/quiltyInsights/QuiltyInsightsFilterStore";
import { QuiltyInsightsListStore } from "../stores/quiltyInsights/QuiltyInsightsListStore";
import { handleError } from "../../../common/src/utility/errorUtils";
import LoadingOverlay from "../../../common/src/components/LoadingOverlay.vue";
import { ProductTypeStore } from "../../../common/src/stores/ProductTypeStore";
import { ServiceTypeStore } from "../../../common/src/stores/ServiceTypeStore";
import InlineFormTreeselect from "../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import FormInput from "../../../landing/src/molecules/form/FormInput.vue";
import { debounce } from "debounce";
import { escapeRegExp } from "lodash";
import NoRecords from "../../../common/src/components/NoRecords.vue";
import SocialFeed from "../molecules/quiltyInsights/SocialFeed.vue";
import { AuthStore } from "../../../common/src/stores/AuthStore";

@Component({
    components: {
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
        SocialFeed,
    },
})
export default class QuiltyInsightsView extends Vue {
    @Inject("container") readonly container!: Container;
    quiltyInsightsFilterStore: QuiltyInsightsFilterStore =
        this.container.get(QuiltyInsightsFilterStore);
    readonly listStore: QuiltyInsightsListStore = this.container.get(QuiltyInsightsListStore);
    readonly productTypeStore: ProductTypeStore = this.container.get(ProductTypeStore);
    readonly serviceTypeStore: ServiceTypeStore = this.container.get(ServiceTypeStore);
    readonly authStore: AuthStore = this.container.get(AuthStore);

    mounted() {
        this.listStore.load().catch(handleError);
        this.productTypeStore.load().catch(handleError);
        this.serviceTypeStore.load().catch(handleError);

        if (this.title) {
            this.listStore.query = this.title;
        }
    }

    created() {
        this.listStore.load();

        if (this.listStore.organizationId) {
            this.reload();
        }
    }

    reload() {
        this.listStore.organizationId = undefined;
        this.listStore.reload().catch(handleError);
    }

    @Watch("listStore.query")
    reloadDebounce = debounce(this.reload, 300);

    get productOptions() {
        return this.productTypeStore.item || [];
    }

    get serviceOptions() {
        return this.serviceTypeStore.item || [];
    }

    get title(): string {
        return this.$route.params.title;
    }

    toggleProducts(productFilterSet: string[]) {
        this.quiltyInsightsFilterStore.productTags = new Set(productFilterSet);
    }

    toggleServices(serviceFilterSet: string[]) {
        this.quiltyInsightsFilterStore.serviceTags = new Set(serviceFilterSet);
    }

    searchingTag(tag: string) {
        if (this.listStore.query) {
            const regexp = new RegExp(escapeRegExp(this.listStore.query.trim()), "i");
            if (regexp.test(tag)) {
                return "primary";
            }
        }

        return "secondary";
    }

    async destoryQuiltyInsights(quiltyInsightsId: string) {
        try {
            var confirmation = confirm(
                "Are you sure you want to delete flash news " + quiltyInsightsId,
            );
            if (confirmation) {
                this.listStore.reload().catch(handleError);
            }
        } catch (e) {}
    }
}
